import { render, staticRenderFns } from "./denegada.vue?vue&type=template&id=3484c910&scoped=true"
import script from "./denegada.vue?vue&type=script&lang=js"
export * from "./denegada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3484c910",
  null
  
)

export default component.exports